import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class CampanhaKeys extends MainKeys {
    public get place() {
        return Places.campanha
    }

    /** Mantém a campanha aberta na URL, para recarregar a página sem perder o acompanhamento. */
    public get newsId() {
        return this._intent.getParameterAsString('campanha') ?? ''
    }

    public set newsId(value: string) {
        this._intent.setParameter('campanha', value || null)
    }
}

export default CampanhaKeys
